// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { IMerchant } from "@/hooks";
import {
  Stack,
  Stepper,
  Step,
  StepLabel,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MerchantAddFormAddressStep } from "./MerchantAddFormAddressStep";
import { MerchantAddFormBankStep } from "./MerchantAddFormBankStep";
import { MerchantAddFormCompanyStep } from "./MerchantAddFormCompanyStep";
import { MerchantAddFormPartnerStep } from "./MerchantAddFormPartnerStep";
import { MerchantAddFormCurrencyStep } from "./MerchantAddFormCurrencyStep";
import { MerchantSettings, MerchantSettingsV2 } from "./v2";

const steps = [
  "Şirket Bilgileri",
  "Yetkili Kişi Bilgileri",
  "Adres Bilgileri",
  "Banka Bilgileri",
  "Para Birimi Kısıtlama",
];

export const MerchantAddForm = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());
  const merchant = useLocation().state as unknown as IMerchant | undefined;

  const [allData, setAllData] = useState({});

  useEffect(() => {
    const savedData = localStorage.getItem('merchantData');
    if (savedData && merchant != null) {

      let merchantData = JSON.parse(savedData);

      if (merchantData && merchantData?.id == merchant?.id) {
        setAllData(JSON.parse(savedData));
      }
    } else if (merchant?.id) {
      setAllData({ ...allData, ...merchant });
    }
  }, [merchant]);

  useEffect(() => {
    if (Object.keys(allData).length > 0) {
      localStorage.setItem('merchantData', JSON.stringify(allData));
    }
  }, [allData]);

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  return <MerchantSettingsV2 merchant={allData} allData={allData} setAllData={setAllData} merchantId={allData?.merchantId} />

  return (
    <Stack flex={1}>
      <Stack>
        <Stepper
          sx={{ px: isDesktop ? 4 : 1, py: 2 }}
          orientation={isDesktop ? "horizontal" : "vertical"}
          activeStep={activeStep}
        >
          {steps.map((label) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Stack>
      {activeStep === 0 && (
        <MerchantAddFormCompanyStep
          merchant={allData}
          onNext={handleNext}
          allData={allData}
          setAllData={setAllData}
        />
      )}
      {activeStep === 1 && (
        <MerchantAddFormPartnerStep
          merchant={allData}
          onNext={handleNext}
          onBack={handleBack}
          allData={allData}
          setAllData={setAllData}
        />
      )}
      {activeStep === 2 && (
        <MerchantAddFormAddressStep
          merchant={allData}
          onNext={handleNext}
          onBack={handleBack}
          allData={allData}
          setAllData={setAllData}
        />
      )}
      {activeStep === 3 && (
        <MerchantAddFormBankStep
          merchant={allData}
          onNext={handleNext}
          onBack={handleBack}
          allData={allData}
          setAllData={setAllData}
        />
      )}
      {activeStep === 4 && (
        <MerchantAddFormCurrencyStep
          merchant={allData}
          onBack={handleBack}
          allData={allData}
          setAllData={setAllData}
        />
      )}
    </Stack>
  );
};
